import React, { useRef } from 'react';
import { useInternationalization } from '@progress/kendo-react-intl';
import { useGlobalizationContext, useTranslation, useSearchContext } from '@cs-cms/state-management';

export const SearchResultsCount: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const intl = useInternationalization();
  const { data, isLoading } = useSearchContext();

  const lastKnownTotalCountRef = useRef<number>(0);
  const totalCount = data?.totalCount ?? 0;

  if (totalCount > 0) {
    lastKnownTotalCountRef.current = totalCount;
  }

  const resultsCount = isLoading && totalCount === 0 ? lastKnownTotalCountRef.current : totalCount;

  return (
    <div className="searchResultsCount">
      {intl.formatNumber(resultsCount, '0')} {translate('custom.toolbar.searchResults')}
    </div>
  );
};
